import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { Typography } from '@material-ui/core';

import * as liveStationReducers from '../reducer';
import * as stnFastDataReducer from '../../station-fastdata/reducer';
import * as fastDataReducers from '../reducer/index';
import * as strings from '../../helpers/strings';

class statisticsInfo extends Component {

  constructor() {
    super()
    this.handle_statisticTitle = this.handle_statisticTitle.bind(this)
  }

  unitConversion(energy) {
    return (parseFloat(energy).toFixed(1) > 10000) ? `${(parseFloat(energy) / 1000).toFixed(1)} M` : parseFloat(energy).toFixed(1) + 'k'
  }

  handle_statisticTitle() {
    const { history } = this.props;
    history.push(`/station-statistics`);
  }

  render() {
    const { getTotalize } = this.props;
    return (
      <div className='statisticsInfoDiv'>
        <Typography variant="h5"
          color={strings.colorPrimary}
          gutterBottom
          onClick={this.handle_statisticTitle}
          style={{ fontSize: '1rem', fontWeight: 500, cursor: 'pointer' }}
        > {strings.lblStatistics} </Typography>
        <ul className='statisticsInfoWrapper'>
          <li className="statisticsInfoInner">System Capacity: {(getTotalize !== null) ? parseFloat(getTotalize.systemCapacity).toFixed(1) + ' kWp' : '0 kWp'} </li>
          <li className="statisticsInfoInner">Annual Energy Yields: {(getTotalize !== null) ? (Number(getTotalize.annualEnergyYields) / 1000).toFixed(1) + ' MWh' : '0 MWh'} </li>
          <li className="statisticsInfoInner">Annual Performance Ratio: {(getTotalize !== null) ? Math.ceil(parseFloat(getTotalize.annualPerformanceRatio)).toFixed(1) + "%" : '0 %'}</li>
          <li className="statisticsInfoInner">Annual Insolations: {(getTotalize !== null) ? Math.ceil(parseFloat(getTotalize.annualInsolation)).toFixed(1) + ' kWh/m²/year' : '0 kWh/m²/year'}</li>
          <li className="statisticsInfoInner">Average Annual Degration: {(getTotalize !== null) ? parseFloat(getTotalize.averageAnnualDegration).toFixed(1) + '%' : '0 %'} </li>
        </ul>
        
      </div>
    )
  }
}


const mapStateToProps = state => ({
  getDashbaordWeatherInfo: stnFastDataReducer.getDashbaordWeatherInfo(state),
  data: liveStationReducers.getLastWindDirection(state),
  getLastFastData: liveStationReducers.getLastFastData(state),
  getTotalize: fastDataReducers.getStnTotalize(state)
})

export default connect(mapStateToProps)(
  withRouter(
    (statisticsInfo)
  )
);